import QuestionPage from '@app-studio-web/ui/pages/QuestionPage'
import { useTranslation } from 'react-i18next'
import { useSubmit } from 'react-router-dom'
import useUpdateMode from '../../hooks/useUpdateMode'
import { saveAnswer } from '../../utils/onboardingStorage'

const QUESTION_KEY = 'red_flags'

export default function RedFlagsPage() {
  const submit = useSubmit()
  const { t } = useTranslation()

  const { isUpdate, postToReactNative } = useUpdateMode()

  const onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    const formData = new FormData(event.currentTarget)
    const formAnswer = formData.get('answer') as string

    const answer = {
      question_key: QUESTION_KEY,
      question: 'What are your biggest red flags?',
      answer_key: formAnswer.toLowerCase(),
      answer: formAnswer,
    }

    if (isUpdate) {
      postToReactNative(answer)
    } else {
      saveAnswer(QUESTION_KEY, answer)
      submit(formData, { method: 'post' })
    }
  }

  return (
    <QuestionPage
      heading={t('pages.onboarding.redFlags.heading')}
      buttons={[
        {
          text: t('pages.onboarding.redFlags.options.loveBombing'),
          value: 'loveBombing',
        },
        {
          text: t('pages.onboarding.redFlags.options.inconsistency'),
          value: 'inconsistency',
        },
        {
          text: t('pages.onboarding.redFlags.options.overSharing'),
          value: 'overSharing',
        },
      ]}
      onSubmit={onSubmit}
      headingSize="text-3xl"
      buttonTextSize="text-base"
      buttonBgColor="bg-white"
    />
  )
}
